var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.874,
    height: 16,
    viewBox: "0 0 10.874 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-location",
    "data-name": "001-location",
    transform: "translate(-23.141 -2.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M31.886,17.011a.234.234,0,0,0,.184.094h0a.233.233,0,0,0,.183-.089c.193-.246,4.717-6.061,4.717-9.744a4.9,4.9,0,1,0-9.8,0c0,1.41.8,3.482,2.366,6.155C30.7,15.4,31.874,17,31.886,17.011Zm.187-14.173a4.439,4.439,0,0,1,4.435,4.435c0,3.11-3.563,8.053-4.43,9.209-.856-1.2-4.439-6.39-4.439-9.209A4.439,4.439,0,0,1,32.073,2.838Z",
    transform: "translate(-3.495)",
    fill: "#356bb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M48.464,20.846a2.817,2.817,0,1,0-2.817,2.817A2.817,2.817,0,0,0,48.464,20.846ZM45.647,23.2A2.351,2.351,0,1,1,48,20.846,2.351,2.351,0,0,1,45.647,23.2Z",
    transform: "translate(-17.069 -13.574)",
    fill: "#356bb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M30.952,101.159a.233.233,0,0,0-.057.462c2,.246,2.654.71,2.654.9,0,.35-1.755,1.03-4.971,1.03s-4.971-.681-4.971-1.03c0-.2.636-.608,2.344-.855a.233.233,0,0,0-.067-.461c-1.251.181-2.743.556-2.743,1.316,0,1.1,3.251,1.5,5.437,1.5s5.437-.4,5.437-1.5C34.015,101.662,32.1,101.3,30.952,101.159Z",
    transform: "translate(0 -85.641)",
    fill: "#356bb0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.58990fef039fc9deb11128532f7134a5.svg";
export { ForwardRef as ReactComponent };